import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15aa3f77"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position-tabs" }
const _hoisted_2 = { class: "tabs-header" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "tabs-content" }
const _hoisted_5 = { class: "tab-pane" }
const _hoisted_6 = { class: "tab-pane" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PositionDetailsTable = _resolveComponent("PositionDetailsTable")!
  const _component_RebalancingHistoryTable = _resolveComponent("RebalancingHistoryTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tab.key,
          class: _normalizeClass(['tab-item', { active: _ctx.activeTab === tab.key }]),
          onClick: ($event: any) => (_ctx.handleTabChange(tab.key))
        }, _toDisplayString(tab.label), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createVNode(_component_PositionDetailsTable, {
          positions: _ctx.positions,
          "color-mode": _ctx.colorMode,
          language: _ctx.language,
          "show-title": false,
          theme: _ctx.theme,
          "hk-delay": _ctx.hkDelay,
          "us-delay": _ctx.usDelay,
          onOrderClick: _ctx.handleOrderClick,
          onRowDoubleClick: _ctx.handleRowDoubleClick
        }, null, 8, ["positions", "color-mode", "language", "theme", "hk-delay", "us-delay", "onOrderClick", "onRowDoubleClick"])
      ], 512), [
        [_vShow, _ctx.activeTab === 'positions']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createVNode(_component_RebalancingHistoryTable, {
          "selected-date": _ctx.selectedDate,
          "color-mode": _ctx.colorMode,
          language: _ctx.language,
          "show-title": false,
          theme: _ctx.theme,
          "hk-delay": _ctx.hkDelay,
          "us-delay": _ctx.usDelay,
          onRowDoubleClick: _ctx.handleRowDoubleClick
        }, null, 8, ["selected-date", "color-mode", "language", "theme", "hk-delay", "us-delay", "onRowDoubleClick"])
      ], 512), [
        [_vShow, _ctx.activeTab === 'rebalancing']
      ])
    ])
  ]))
}